var map = {
	"./bike_delivery_featured_img.svg": 5757,
	"./bike_delivery_img_1.svg": 2498,
	"./bike_delivery_img_2.svg": 5719,
	"./bike_delivery_img_3.svg": 8376,
	"./bike_delivery_img_4.svg": 6689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3820;